module.exports = __webpack_public_path__ + "static/media/sidebar-email-selected.7ae86212.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-email-selected.svg
// module id = 792
// module chunks = 0